import { ControlUser } from './controlUser';
import { Deserializable } from './deserializable';


export class AliasOwnerRel implements Deserializable {

  ownerUid: string;
  owner: ControlUser;
  uid: string;
  id: string;
  aliasUid: string;
  alias: ControlUser;
  publicName: string;
  availableFeature: string[];

  deserialize(input: any) {

    Object.assign(this, input);

    if (this.publicName === undefined || this.publicName === null || this.publicName.trim() === "") {
      this.publicName = this.alias.email;
    }

    return this;
  }
}


// AliasOwnerRel  {
//   String ownerUid;
//   Ref<ControlUser> owner;
//   String aliasUid;
//   Ref<ControlUser> alias;
// }
